import type { MetaFunction } from 'react-router';
import { getCanonicalURL } from '@cx-web/utils/getCanonicalURL';

import { type loader } from './loader';

export const meta: MetaFunction<never, { [routeId: string]: typeof loader }> = ({ location, matches }) => {
  const data = matches.find(match => /betting-splits$/.test(match.id))?.data;

  return [
    { title: `Public Betting Splits | Oddschecker Plus` },
    {
      name: 'description',
      content: `Public Betting Splits | Oddschecker Plus`,
    },
    {
      tagName: 'link',
      rel: 'canonical',
      href: getCanonicalURL(data?.url.toString(), location.pathname),
    },
  ];
};
